import { render, staticRenderFns } from "./tech-sidebar.vue?vue&type=template&id=c19509d4&scoped=true"
import script from "./tech-sidebar.vue?vue&type=script&lang=ts"
export * from "./tech-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./tech-sidebar.vue?vue&type=style&index=0&id=c19509d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19509d4",
  null
  
)

export default component.exports